module.exports = __webpack_public_path__ + "static/about2-9611423012e0bb23e32c541ca2dfcd28.jpg";